import React from 'react';

import { Table, } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Switch from '@material-ui/core/Switch';
import DnsIcon from '@material-ui/icons/Dns';

import history from '../../history';


function CompaniesTable({ companies, onChangeCompanyActiveState, }) {
  function onAccessCompany(company) {
    localStorage.setItem('idEmpresa', company._id);
    localStorage.setItem('name_empresa', company.name);
    history.push('/cad/empresas/Show');
  }


  return (
    <Table
      striped
      bordered
      hover
    >
      <thead>
        <tr>
          <th>
            NOME
          </th>
          <th>
            Data da criação
          </th>
          <th>
            Acessar a empresa
          </th>
          <th>
            Ativa?
          </th>
        </tr>
      </thead>

      <tbody>
        {
          companies
            .map((company) => {
              const isActive = 1 === company.ativa;

              return (
                <tr key={company._id} >
                  <td>
                    {company.name}
                  </td>
                  <td>
                    {new Date(company.createdAt).toLocaleDateString()}
                  </td>

                  <td>
                    <Button
                      variant="outline-success"
                      onClick={() => onAccessCompany(company)}
                    >
                      Acessar <DnsIcon />
                    </Button>
                  </td>

                  <td>
                    <Switch
                      color="primary"
                      checked={isActive}
                      onChange={() => onChangeCompanyActiveState(company._id, !isActive)}
                      name="checkedA"
                      inputProps={{
                        'aria-label': 'secondary checkbox',
                      }}
                    />
                  </td>
                </tr>
              );
            })
        }
      </tbody>
    </Table>
  )
}

export default CompaniesTable;
